export function mapPageTreeToProcurePageModel(page, parents, assetId) {
    let child = { AssetRefId: page.PageAssetId, PageId: page.PageId, Page: null };

    for (const parent of parents) {
        child = { AssetRefId: parent.PageAssetId, PageId: parent.PageId, Page: child };
    }

    return { AssetRefId: assetId, Page: child };
}
